module.exports = __webpack_public_path__ + "static/media/fourkites-logo.e559c2bd.svg";